export class MesasOcupadasModel {
  numeroComanda: number;
  dataHoraPedido: string;
  statusPedido: string;
  imprimiuPreConta: boolean;
  nomeCliente: string;
}
